<template>
  <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 350px;">
    <span>{{ $t("loading") }}</span>
  </div>
  <apexchart
    v-else
    type="bar"
    height="350"
    :options="thisWeeksSalesPurchasesChart"
    :series="series"
  ></apexchart>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import type { DashboardMonthlyItem } from "@/services/dashboard";

export default defineComponent({
  name: "ThisWeeksSalesPurchasesChart",
  props: {
    items: {
      type: Array as () => DashboardMonthlyItem[],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const series = computed(() => ([
      {
        name: t("dashboard_page.sales_series"),
        data: props.items.map((item) => Number(item.sales || 0)),
      },
      {
        name: t("dashboard_page.purchase_series"),
        data: props.items.map((item) => Number(item.purchases || 0)),
      },
    ]));
    const thisWeeksSalesPurchasesChart = computed(() => ({
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ["#4F46E5", "#BBBCF1"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 1,
        colors: ["transparent"],
      },
      xaxis: {
        categories: props.items.map((item) => item.month),
        colors: "#EEF3FA",
      },
      yaxis: {
        title: {
          text: `$ (${t("dashboard_page.actual_amount")})`,
        },
      },
      grid: {
        show: true,
        borderColor: "#EEF3FA",
        strokeDashArray: 0,
        position: "back",
      },
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "right",
        floating: false,
        fontSize: "16px",
        fontWeight: 500,
        labels: {
          colors: "#838A95",
        },
        markers: {
          width: 16,
          height: 16,
          radius: 2,
          offsetX: 0,
          offsetY: 0,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val: number) {
            return "$ " + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          },
        },
      },
    }));

    return {
      series,
      thisWeeksSalesPurchasesChart,
    };
  },
});
</script>
